import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-omitir-onboarding',
  standalone: false,
  templateUrl: './omitir-onboarding.component.html',
  styleUrl: './omitir-onboarding.component.less'
})
export class OmitirOnboardingComponent {

  @Input() showBanner!: boolean;

  constructor(private router: Router) {

  }

  irOnboarding() {
    this.router.navigate(['/home/onboarding']);
  }

}
